import avatar from  "../../../images/avatar.png";


export const testimonialData = [
    {
        name: 'Adeola',
        message: 'Customer service was incredibly helpful and resolved my issue within hours. Truly appreciate the support!',
        rating: 4,
        time: 1,
        image: avatar
    },
    {
        name: 'Precious',
        message: "Whoa, it’s so fast and I got a remote job in a month! From earning just 150k to over a million in a month! Ai is scary.",
        rating: 5,
        time: 1,
        image: avatar
    },
    {
        name: 'Efe',
        message: 'You are the best easy and fast services.',
        rating: 4.5,
        time: 2,
        image: avatar
    },
    {
        name: 'Chijioke',
        message: 'It helped me create a professional resume in just a few minutes. Highly recommended.',
        rating: 5,
        time: 3,
        image: avatar
    },
    {
        name: 'Soni',
        message: 'This is such an amazing platform. My resumé is amazing ✨️✨️ and A1 on remote jobs!.',
        rating: 5,
        time: 7,
        image: avatar
    },
    {
        name: 'Olanrewaju',
        message: "I had been unemployed for a while, and I was starting to lose hope. Bubble Ai gave me a new lease on life. They helped me identify my strengths and find jobs that aligned with my career goals. I'm now working in a fulfilling role.",
        rating: 5,
        time: 7,
        image: avatar
    },
    {
        name: 'Eseoghene',
        message: "The AI Application automation is a lifesaver! It made the daunting task of applying to jobs so much easier. I would definitely recommend it to anyone in need of a job.",
        rating: 5,
        time: 8,
        image: avatar
    },
    {
        name: 'Chrysancthus',
        message: "This is so creative and extraordinary.... will write more when I get a job.",
        rating: 4,
        time: 9,
        image: avatar
    },
    {
        name: 'Romulus',
        message: "It's a great start, I look forward to ana amazing experiences with bubble.ai",
        rating: 4.5,
        time: 10,
        image: avatar
    },
];

